import api from '@/shared/utils/apiConfig';

export interface CustomerSourceActorRef {
  id: string;
  name: string;
}

export interface CustomerSource {
  id: string;
  name: string;
  code: string;
  isSystem: boolean;
  isActive: boolean;
  sortOrder: number;
  createdBy?: CustomerSourceActorRef;
  updatedBy?: CustomerSourceActorRef;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCustomerSourcePayload {
  name: string;
  sortOrder?: number;
}

export interface UpdateCustomerSourcePayload {
  name?: string;
  isActive?: boolean;
  sortOrder?: number;
}

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  count?: number;
  message?: string;
}

export const customerSourceAPI = {
  getAll: async (includeInactive = false): Promise<ApiResponse<CustomerSource[]>> => {
    const response = await api.get('/customer-sources', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return response.data;
  },

  create: async (payload: CreateCustomerSourcePayload): Promise<ApiResponse<CustomerSource>> => {
    const response = await api.post('/customer-sources', payload);
    return response.data;
  },

  update: async (
    id: string,
    payload: UpdateCustomerSourcePayload
  ): Promise<ApiResponse<CustomerSource>> => {
    const response = await api.put(`/customer-sources/${id}`, payload);
    return response.data;
  },

  deactivate: async (id: string): Promise<ApiResponse<CustomerSource>> => {
    const response = await api.delete(`/customer-sources/${id}`);
    return response.data;
  },
};

/** Active catalog by default. Same shape as the customer-source query cache. */
export const fetchCustomerSources = async (
  includeInactive = false
): Promise<CustomerSource[]> => {
  const response = await customerSourceAPI.getAll(includeInactive);
  return response.data ?? [];
};
